import React from "react";
import { useControls, button, buttonGroup } from "leva";
import { useState, useEffect, useRef } from "react";
import SubmitForm from "./SubmitForm.jsx"
// import * as MyLibrary from 'leva';
// console.log(MyLibrary);

const verbose = false;
const disableRenderFLag = "NONE";



function CreateLevaFromJson({ iframeRef, store }) {
    verbose && console.log("RENDERED!")
    const isIframeLoaded = useRef(false);
    const [showSubmitForm, setShowSubmitForm] = useState(false);
    const handleFormSubmit = () => { setShowSubmitForm(false); };
    // const [renderStates, setRenderStates] =  useState(() => {
    //     const initialStates = {};
    //     config.forEach(item => {
    //         if(item.props.hasOwnProperty("render")){
    //             initialStates[item.name] = item.props.render !== defaultUI;
    //         }
    //     });
    //     return initialStates;
    // });
    // const defaultUI = "#000000";
    const config = window.AppConfig.config;
    const configLayout = [
        { "name": "randomize", "type": "button", props: { "label": "reload local", "onChange": "reloadIframe" } },
        { "name": "C1", props: { "label": "", value: "#000000", }, lookup: { "onChange": "updateColors" } },
        { "name": "C2", props: { "label": "", value: "#000000", render: true, }, lookup: { "onChange": "updateColors" } },
        { "name": "C3", props: { "label": "", value: "#000000", render: true, }, lookup: { "onChange": "updateColors" } },
        { "name": "C4", props: { "label": "", value: "#000000", render: true, }, lookup: { "onChange": "updateColors" } },
        { "name": "C5", props: { "label": "", value: "#000000", render: true, }, lookup: { "onChange": "updateColors" } },
        { "name": "C6", props: { "label": "", value: "#000000", render: true, }, lookup: { "onChange": "updateColors" } },
        { "name": "email me", "type": "button", props: { "label": "email me", "onChange": "sendEmail" } },
        { "name": "download", "type": "button", props: { "label": "download" }, lookup: { "onChange": "saveLargeCanvas" } },

        // {"name":"logM" , "type": "button",    props:{"label":"logM" }, lookup:{"onChange":"logM"}},
        // {"name":"logCols" , "type": "button",props:{"label":"logCols"}, lookup:{"onChange":"logCols"}},
        // {"name":"logM" , "type": "button",   props:{"label":"noop", "onChange":"noop" }},

        // {"name":"t001" ,    props:{"label":"",value:"", editable:false }},
        // {"name":"t002" ,    props:{"label":"",value:"",  }},

    ]
    

    const localFn = {
        noop: function(){
            verbose && console.log("noop")
        },
        reloadIframe:function () {
            if (iframeRef.current) {
                iframeRef.current.src = iframeRef.current.src;
            }
        },
        sendEmail: function () {
            setShowSubmitForm(true)
        },
        openUrlInNewTab: function (url = "https://trameparis.com/collections/enlace-by-aranda-lasch") {
            window.open(url, '_blank');
        },
        setEdition: function () {
            verbose && console.log("setEdition")
            let start = window.AppConfig.editionStart || 0
            let idx = store.get("Edition")
            if (start === 1) {
                idx -= 1
            }
            verbose && console.log("start", start)
            verbose && console.log("idx", idx)
            if (typeof idx === 'number') {
                let val
                if (start === "finale") {//for finale, this is dumb but it works
                    let a = [36, 75, 143, 148, 230, 242, 251, 252, 264, 612, 681, 780, 842]
                    idx = a.indexOf(idx)
                    val = window.AppConfig.seeds[idx]
                    verbose && console.log(val)
                } else {
                    val = window.AppConfig.seeds[idx]
                }
                if (val) {
                    verbose && console.log(val)
                    updateIframeVals("nextSeed", val)
                    runIframeFn("setSeed")
                }
            }
        },
    }
    
    function runLocalFnfunc(func) {
        localFn[func]();
    }
    function runIframeFn(func) {
        verbose && console.log(func)
        verbose && console.log(iframeRef.current.contentWindow[func])
        if (iframeRef.current.contentWindow[func]) {
            iframeRef.current.contentWindow[func]();
        }
    }
    function runIframeFnArg(func, Arg) {
        if (iframeRef.current.contentWindow[func]) {
            iframeRef.current.contentWindow[func](Arg);
        }
    }
    function passUItoWindow(item) {
        let val = store.get(item.name)
        verbose && console.log("passing", item.name, val)
        updateIframeVals(item.name, val)
        verbose && console.log(config)
    }
    function updateIframeVals(target, data) {
        if (iframeRef.current.contentWindow.updateM) {
            iframeRef.current.contentWindow.updateM(target, data)
        }
    }



    const colorOptions = {
        '#cd9323': <div style={{ backgroundColor: '#cd9323', width: '100%', height: '100%' }} />,
        '#1a53d8': <div style={{ backgroundColor: '#1a53d8', width: '100%', height: '100%' }} />,
        '#9a2151': <div style={{ backgroundColor: '#9a2151', width: '100%', height: '100%' }} />,
        '#0d6416': <div style={{ backgroundColor: '#0d6416', width: '100%', height: '100%' }} />,
        '#8d2808': <div style={{ backgroundColor: '#8d2808', width: '100%', height: '100%' }} />,
      };
    
    // Initializing controls based on the configuration
    const controls = config.reduce((acc, item) => {
        if (item.type === "button") {
            if(item.props.hasOwnProperty("disabled")){
                var props = {disabled:item.props.disabled}
            }else{
                var props = {disabled:false}
            }
            if (item.lookup?.onChange) {
                acc[item.name] = button(() => { runIframeFn(item.lookup.onChange) }, props);
            }
            else {
                acc[item.name] = button(() => { runLocalFnfunc(item.props.onChange);  }, props);
            }
            acc[item.name].label = item.label
        } else if (item.type === "buttonGroup" &&  item.hasOwnProperty("buttonGroup")) { // btn group
            const btns = {}
            for(let btn in item.buttonGroup){
                btns[btn] = () => {};
                if(item.buttonGroup[btn].hasOwnProperty("lookup")){
                    btns[btn] = ()=>{runIframeFn(item.buttonGroup[btn].lookup.onChange);}
                }else if(item.buttonGroup[btn].hasOwnProperty("local")) {
                    btns[btn] = ()=>{runLocalFnfunc(item.buttonGroup[btn].local.onchange);}
                }
            }
            acc[item.name] = buttonGroup(btns)
     
        } else if(item.type === "colorSwatch") {
    

        } else {
            acc[item.name] = { ...item.props };
            if (item.props.onChange) {
                acc[item.name].onChange = (() => {
                    if (isIframeLoaded.current) {
                        runLocalFnfunc(item.props.onChange)
                    }
                })
            } else if (item.lookup) {
                acc[item.name].onChange = (() => {
                    if (isIframeLoaded.current) {
                        passUItoWindow(item)
                        runIframeFn(item.lookup.onChange)
                    }
                })
            } else { // for uniform updates without a FN, should prop just add a noop inside the app so there has to be a delcared onchange string? 
                // solution to above: just add an onChange funcito nthat doesnt exist. passUItoWindow gets called, runIframeFn doesnt pass the if check
                acc[item.name].onChange = (() => {
                    if (isIframeLoaded.current) {
                        passUItoWindow(item)
                    }
                })
            }
            
            if (item.hasOwnProperty("renderOnDisable")) {// dont render if item is disabled
                    acc[item.name].render = () => {
                        // console.log("RENDER",item.name, store.getData()[item.name].disabled)
                        return ( !store.getData()[item.name].disabled  ) 
                    }
            }

            if (item.props.optionsLength) { // for Edition Select
                let start = window.AppConfig.editionStart || 0
                acc[item.name].options = Array.from({ length: item.props.optionsLength }, (_, index) => index + start)
            }
        }

        // acc[item.name] =  {
        //     label: 'Select Color',
        //     value: '#cd9323',
        //     options: Object.keys(colorOptions),
        //     image: colorOptions,
        //   },

        verbose && console.log("")
        verbose && console.log("ctnl", acc[item.name])
        verbose && console.log("item", item)
        verbose && console.log("src", config[item.name])
        verbose && console.log("")
        // debugger
        return acc;
    }, {});
    

    // controls["colorImgTest"] =  {
    //     label: 'Select Color',
    //     value: '#cd9323',
    //     options: Object.keys(colorOptions),
    //     image: colorOptions,
    //   },

    window.updateParent = updateParent
    function updateParent(M){
        // store.set({ ["C1"]: "#00ff00" }, false);
        // config.forEach(item => {  
        //     if(item?.type === "updatable"){
        //         store.set({ [item.name]: M.var[item.name] }, false);
        //     }
        // })
        verbose && console.log("updateParent")
        updateControls()
    }


    // console.log("controls",controls)
    const updateControls = () => {
        if (iframeRef.current) {
            isIframeLoaded.current = false;
            config.forEach(item => {                        // rewrite with controls, config no loger same opbject......   only item.props.value  will be out of date? and only happens before iframe loads... so they will be tha same?
                if (item.lookup && item.type !== "button") {
                    if (iframeRef.current.contentWindow.M) {
                        const value = iframeRef.current.contentWindow.M.var[item.name] ?? item.props.value ?? 'default value';
                        // if (value === store.get(item.name)) { return }//exit if the value is the same, dont call onChange becuase disabled settings require a value change for state, we can no longer do this. 
                        if (value === disableRenderFLag && item.hasOwnProperty("renderOnDisable")) { // if the value is NONE, we disable the control. this happens when the app is telling us this var isnt active. 
                            // console.log(store.getData())
                            // console.log(store.getData()[item.name])
                            // store.setSettingsAtPath(item.name, {render:()=>false})
                            // store.setSettingsAtPath(item.name, {render2:defaultUI})
                            verbose && console.log(`disabled ${item.name}`)
                            store.disableInputAtPath(item.name, true)
                            // store.set({ [item.name]: value }, false);
                        } else {
                            verbose && console.log("active control   ", item.name, "set to", value)
                            if(item.hasOwnProperty("renderOnDisable")){
                                verbose && console.log(`enabled ${item.name}`);
                                store.disableInputAtPath(item.name, false); 
                            }
                            store.set({ [item.name]: value }, false);
                        }
                    }
                }else if (item.type === "button" && item.props.hasOwnProperty("disabled")){
                    //disable, cant use disableInputAtPath as buttons dont rerender...
                    if (iframeRef.current.contentWindow.M) {
                        const value = iframeRef.current.contentWindow.M.var[item.name]
                        store.setSettingsAtPath(item.name, { disabled: value }); 
                    }
                }
            });
            isIframeLoaded.current = true;
            verbose && console.log("set isIframeLoaded to", isIframeLoaded.current)
        }
    };


    useEffect(() => {
        const currentIframe = iframeRef.current;
        currentIframe.addEventListener('load', updateControls);
        updateControls();

        return () => {
            if (currentIframe) {
                currentIframe.removeEventListener('load', updateControls);
                isIframeLoaded.current = false;
            }
        };
    }, [iframeRef, store, config, controls,iframeRef?.current?.contentWindow?.M.var]);

    verbose && console.log("controls", controls)
    verbose && console.log(store)
    useControls(controls, { store });


    return (
        <>
            {showSubmitForm && <SubmitForm onSubmit={handleFormSubmit} iframeRef={iframeRef} uploadM={true} uploadImg={true} />}
        </>
    )
}

export default CreateLevaFromJson;
